var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sugr_btn"},on:{"mouseup":function($event){return _vm.emitClick($event)}}},[_c('div',{class:['btn',this.sugrType]},[_c('span',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }